import { isInteger } from 'lodash'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import IconBadge from './icon-badge'

const ConflictBadge = ({ count, text = '' }) => {
  const tooltipText = isInteger(count) ? `${count} Conflicts present` : undefined
  const displayCount = isInteger(count) ? count : undefined
  const displayText = !isInteger(count) ? (text.length > 0 ? text : 'Conflict') : undefined

  return (
    <IconBadge
      icon={faExclamationTriangle}
      iconColor="text-warning"
      tooltipText={tooltipText}
      tooltipPlacement="bottom"
      count={displayCount}
      text={displayText}
      className="mx-1"
    />
  )
}

export default ConflictBadge
